import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
/* eslint-disable */
export default new Vuex.Store ({
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    state: {
        userDetails: null,
        allOADUsers:null,
        credentialCache:{}
    },
    mutations: {
        globalUser(state, user) {
            state.userDetails = user
        },
        credentialCache(state, cache)
        {
            state.credentialCache = cache;
        }
    },
    getters: {
        credentialCache: state => {
            return state.credentialCache;
        },
        userEmail: state => {
          return state.userDetails.userEmail
        }
      }
});


// WEBPACK FOOTER //
// ./src/store/index.js